import '../styles/LessonCard.css';
import '../styles/LessonStatus.css';

import React, { MouseEvent, useState } from 'react';

import AlertDialog from '../../shared/components/AlertDialog';
import AuthService from '../../shared/services/AuthService';
import Box from '@mui/material/Box';
import CertIcon from './CertIcon';
import CertService from '../../report/services/CertService';
import Config from '../../shared/config';
import { CourseLessonVm } from '../models/LessonVm';
import FileService from '../../shared/services/FileService';
import Grid from '@mui/material/Unstable_Grid2';
import { LessonAttempt } from '../models/LessonAttempt';
import LessonAttemptText from './LessonAttemptText';
import LessonService from '../services/LessonService';
import LockIcon from './LockIcon';
import Overlay from '../../shared/components/Overlay';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface AttemptCardProps {
  lesson: CourseLessonVm;
  oldAttempt?: LessonAttempt;
  onLaunchCourseLesson: (
    lesson: CourseLessonVm,
    oldAttempt: LessonAttempt
  ) => void;
}

const AttemptCard = (props: AttemptCardProps) => {
  const {
    title,
    cert,
    type,
    lessonkey,
    moduleProgressStatus,
    completionType,
    latestPortfolioAttempt
  } = props.lesson;

  const currentAttempt = props.oldAttempt ?? latestPortfolioAttempt;
  const attemptStatus =
    moduleProgressStatus === 'L'
      ? moduleProgressStatus
      : currentAttempt?.status || 'N';

  const [fetchingCert, setFetchingCert] = useState(false);
  const [fetchCertError, setFetchCertError] = useState(false);

  const handleCardClick = () => {
    props.onLaunchCourseLesson(props.lesson, props.oldAttempt);
  };

  const handleCertIconClick = (lessonkey: string) => {
    setFetchingCert(true);
    const promise = isNaN(+lessonkey)
      ? CertService.getCertFile(AuthService.Username, lessonkey)
      : CertService.getModuleCertificate(AuthService.Userkey, +lessonkey);
    promise
      .then((data) => {
        setFetchingCert(false);
        FileService.open(data);
      })
      .catch(() => {
        setFetchingCert(false);
        setFetchCertError(true);
      });
  };

  const handleCertErrorClose = () => {
    setFetchCertError(false);
  };

  return (
    <>
      <Paper
        elevation={2}
        className={`attempt-card-paper ${
          props.oldAttempt ? 'old-attempt' : ''
        }`}
        onClick={handleCardClick}
      >
        <Grid container alignItems="center" wrap="nowrap" spacing={1}>
          <Grid className={'attempt-card-title'}>
            {props.oldAttempt ? (
              <LessonAttemptText
                lessonAttempt={props.oldAttempt}
                label="Previous attempt created:"
              />
            ) : (
              <Typography variant="body1" noWrap={true}>
                {title}
              </Typography>
            )}
          </Grid>

          <Grid container alignItems={'center'} justifyContent={'center'}>
            {Config.ENV === 'local' && currentAttempt && (
              <Grid style={{ fontSize: '10px' }}>
                {`Attempt: ${currentAttempt.layer}`}
              </Grid>
            )}
            {cert && !props.oldAttempt && (
              <Grid>
                <Box marginRight={2}>
                  <CertIcon
                    status={LessonService.toCertStatus(
                      moduleProgressStatus || 'N',
                      cert
                    )}
                    onClick={(e: MouseEvent<HTMLDivElement>) => {
                      e.stopPropagation();
                      handleCertIconClick(`${lessonkey}`);
                    }}
                  />
                </Box>
              </Grid>
            )}
            <Grid style={{ textAlign: 'center' }}>
              <Grid container spacing={1}>
                {attemptStatus === 'L' && (
                  <Grid>
                    <LockIcon />
                  </Grid>
                )}
                <Grid>
                  <Typography
                    variant="button"
                    style={{
                      color: LessonService.getStatusColor(attemptStatus)
                    }}
                  >
                    {LessonService.toStatusText(
                      attemptStatus,
                      type,
                      completionType
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      {fetchingCert && <Overlay spinner message="Downloading certificate..." />}
      {fetchCertError && (
        <AlertDialog
          title="Certificate"
          message="Failed to download the certificate."
          onClose={handleCertErrorClose}
        />
      )}
    </>
  );
};

export default AttemptCard;
